<template>
  <div class="form">
    <h1 class="form__title" style="text-align: center">
      {{ $t("services provision procedure") }}
    </h1>
    <ul class="doc_list" style="color: white">
      <!--      :href="`${config.fileAbsUrl}/v1/document/get-user-manual`"-->
      <li>
        {{ $t("contract") }}
        <a
          :href="`${config.fileAbsUrl}/v1/document/get-broker-file`"
          target="_blank"
          download
        >
          {{ $t("link") }}</a
        >
      </li>
      <li>
        {{ $t("tariffs") }}
        <a
          :href="`${config.fileAbsUrl}/v1/document/get-rates-file`"
          target="_blank"
          download
        >
          {{ $t("link") }}</a
        >
      </li>
      <li>
        {{ $t("user manual") }}
        <a
          :href="`${config.fileAbsUrl}/v1/document/get-user-manual`"
          target="_blank"
          download
        >
          {{ $t("link") }}</a
        >
      </li>
    </ul>
    <!--    <p class="form__paragraph" style="font-size: 14px;">-->
    <!--      Пожалуйста, убедитесь, что вы прочитали всю информацию ниже, по условиям-->
    <!--      работы FHS и нажмите кнопку Принимаю, для подтверждения. Вы принимаете-->
    <!--      нижеследующее: Общие коммерческие условия АО «FIRST HEARTLAND SECURITIES»,-->
    <!--      Заявление о раскрытии рисков по комплексным продуктам, Коммерческие-->
    <!--      условия торговли ценными бумагами, Коммерческие условия управления-->
    <!--      хранением ценностей, Коммерческие условия международных переводов средств,-->
    <!--      а также Политику в отношении конфликтов интересов и Политику наилучшего-->
    <!--      исполнения. Все вышеуказанное можно найти в разделе Правила и условия.-->
    <!--      Обращаем ваше внимание на то, что все эти документы могут периодически-->
    <!--      изменяться.-->
    <!--    </p>-->
    <!--    <br />-->
    <!--    <div class="commercial-condition-text">-->
    <!--      Я заявляю о своем согласии с условиями договора: я ознакомился, понял и-->
    <!--      согласен с Общими условиями договора (включая уведомление о рисках),-->
    <!--      коммерческими условиями торговли ценными бумагами, коммерческими условиями-->
    <!--      депозитарных операций, коммерческими условиями международных переводов-->
    <!--      денежных средств, условиями использования, размерам комиссий, сборов и-->
    <!--      маржи, а также со всем содержанием документа; я понимаю и согласен с тем,-->
    <!--      что Общие коммерческие условия договора (включая Уведомление о риске),-->
    <!--      Коммерческие условия торговли ценными бумагами, Коммерческие условия-->
    <!--      депозитарных операций, Коммерческие условия международных переводов-->
    <!--      денежных средств, Информация о поведении на рынке, Система комиссионных,-->
    <!--      сборов и ставок маржи, а также Политика в отношении конфликтов интересов и-->
    <!--      Политика в отношении наилучшего исполнения вместе с любыми другими-->
    <!--      соответствующими условиями и положениями (с периодически вносимыми в них-->
    <!--      изменениями) полностью регламентируют мои торговые взаимоотношения с FHS;-->
    <!--      я получил, прочитал и понял информационный материал, касающийся-->
    <!--      соответствующих продуктов. Кроме того, я проинформирован и согласен с тем,-->
    <!--      что с информационным материалом о продуктах можно всегда ознакомиться на-->
    <!--      веб-сейте АО «FIRST HEARTLAND SECURITIES»; и я получил удовлетворительные-->
    <!--      ответы на все мои вопросы относительно положений договора и прочих-->
    <!--      аспектов использования соответствующих продуктов Я осознаю и соглашаюсь с-->
    <!--      тем, что личные данные, использованные при регистрации: Могут быть-->
    <!--      переданы представляющему брокеру с целью проведения комплексной проверки и-->
    <!--      подтверждения моей заявки при условии назначения мной представляющего-->
    <!--      брокера. Могут быть переданы третьей стороне, выступающей от имени АО-->
    <!--      «FIRST HEARTLAND SECURITIES» с целью проведения клиентского анализа и-->
    <!--      последующего использования АО «FIRST HEARTLAND SECURITIES» в маркетинговых-->
    <!--      целях. Могут быть использованы сторонним провайдером аутентификационных-->
    <!--      услуг в ходе проверки моей личности. В ходе контроля сторонний провайдер-->
    <!--      аутентификационных услуг может проверить указанную мной информацию с-->
    <!--      помощью любой базы данных (общедоступной или нет), к которой он имеет-->
    <!--      доступ. Провайдер также может использовать мою личную информацию в будущем-->
    <!--      для помощи другим компаниями в целях контроля. Результаты поиска будут-->
    <!--      сохранены. Далее, своим согласием с настоящими условиями я подтверждаю,-->
    <!--      что: Личная информация, указанная мной в данной форме, является верной, и-->
    <!--      я понимаю, что должен немедленно проинформировать АО «FIRST HEARTLAND-->
    <!--      SECURITIES» о любых изменениях предоставленных мной сведений; Сумма-->
    <!--      инвестиций была выбрана мной с учетом моих финансовых возможностей и-->
    <!--      является разумной. Далее, принятием настоящих условий я выражаю согласие с-->
    <!--      тем, что: Мои личные данные, включая имя, персональный код пользователя-->
    <!--      (CPR), адрес и т.д., а также клиентская информация, включая данные учетной-->
    <!--      записи, входные данные, инвестиции и т.д., указанные мной при регистрации-->
    <!--      в качестве клиента АО «FIRST HEARTLAND SECURITIES» или позднее, или-->
    <!--      которые могут попасть в распоряжение АО «FIRST HEARTLAND SECURITIES»-->
    <!--      другим путем, могут быть переданы другим компаниям, входящим в FIRST-->
    <!--      HEARTLAND GROUP; Эта информация может быть раскрыта в целях выполнения-->
    <!--      требований регулирующих органов (в т.ч. по Закону РК о мерах по-->
    <!--      предотвращению отмывания денег), управления рисками, предоставления-->
    <!--      инвестиционных и прочих услуг, оказываемых FIRST HEARTLAND GROUP, а также-->
    <!--      маркетинга и управления отношениями с клиентами.-->
    <!--    </div>-->
    <div class="form__row form__row_align-center form__checkbox-container">
      <input
        type="checkbox"
        class="form__input"
        id="confirmation"
        v-model="conditionAccepted"
      />
      <label for="confirmation" class="form__label">
        &nbsp;
        {{ $t("agreement terms confirm") }}
      </label>
    </div>
    <hr class="horizontal-line" />
    <p class="form__paragraph">
      {{ $t("sms confirm sent") }}
    </p>
    <br />
    <div class="input-container">
      <label for="user-phone" class="label">
        {{ $t("mobile number") }}
        <span class="form__red">*</span>
      </label>
      <input
        type="tel"
        class="input wide"
        :placeholder="$t('mobile number')"
        required
        maxlength="16"
        id="user-phone"
        v-model="formatedPhoneValue"
        @keyup="formatPhone"
        @blur="formatPhone"
      />
    </div>
    <button
      v-if="isChanged"
      class="button filled form__submit-button re_send_btn"
      @click="savePhone"
    >
      {{ $t("save") }}
    </button>
    <button
      v-else
      class="button form__submit-button re_send_btn"
      :disabled="timer_seconds > 0"
      @click="generateVerifyCode"
    >
      {{ $t("send sms code") }}
      {{ timer_seconds > 0 ? $t("repeatedly through") + `${time}` : "" }}
    </button>
    <div></div>
    <div></div>
    <div v-if="codeVerification">
      <br />
      <label for="user-phone" class="label">
        {{ $t("verification code") }}
        <span class="form__red">*</span>
      </label>
      <input
        type="text"
        v-model="code"
        class="input wide"
        :placeholder="$t('verification code')"
      />
    </div>
    <button
      class="button filled form__submit-button "
      @click="sendConfirmCode"
      v-if="codeVerification"
    >
      {{ $t("check code") }}
    </button>
  </div>
</template>
<style>
.doc_list {
  list-style: none;
}
.doc_list li {
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  margin-bottom: 5px;
}
.commercial-condition-text {
  width: 100%;
  height: 300px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 15px;
  overflow: scroll;
  font-size: 10px;
  box-sizing: border-box;
  border-radius: 5px;
}
</style>
<script>
import { FhsAxios } from "../../../services/axios";
import RegFormMixin from "../form_mixin";
import mn from "moment";
export default {
  props: ["user_profile"],
  data() {
    return {
      time: "2:00",
      timer_seconds: 0,
      re_send: false,
      codeVerification: false,
      conditionAccepted: false,
      oldPhoneValue: null,
      code: "",
      formatedPhoneValue: ""
    };
  },
  mixins: [RegFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchData();
    }
  },
  computed: {
    isChanged() {
      return (
        JSON.stringify(this.formatedPhoneValue) !==
          JSON.stringify(this.oldPhoneValue) &&
        this.formatedPhoneValue.length >= 9
      );
    }
  },
  methods: {
    timer(value) {
      this.re_send = true;
      this.timer_seconds = value || 10;
      let x = setInterval(() => {
        if (this.timer_seconds > 0) {
          this.timer_seconds -= 1;
          this.time = mn(this.timer_seconds * 1000).format("m:ss");
        } else {
          clearInterval(x);
        }
      }, 1000);
      // Update the count down every 1 second
    },
    nextStep() {
      if (this.isUserLegal) {
        this.$router.push({ name: "register-finish" });
        return;
      }
      this.$router.push({ name: "file-upload" });
    },
    fetchData() {
      try {
        if (this.user_profile.user) {
          this.formatedPhoneValue = this.user_profile.user.phone;
          this.oldPhoneValue = this.user_profile.user.phone;
        }
      } catch (e) {
        console.log(e);
      }
    },
    formatPhone() {
      let num = this.formatedPhoneValue.replace(/\D/g, "").split(/(?=.)/);
      let i = num.length - 1;
      if (0 <= i) num.unshift("+");
      if (1 <= i) num.splice(2, 0, " ");
      if (4 <= i) num.splice(6, 0, " ");
      if (7 <= i) num.splice(10, 0, "-");
      if (9 <= i) num.splice(13, 0, "-");
      this.formatedPhoneValue = num.join("");
    },
    sendConfirmCode() {
      if (!(this.code.length > 0)) {
        this.$toasted.show(this.$t("input code"));
        return;
      }
      let url = `signup/check-confirm-code`;
      FhsAxios.post(url, {
        code: this.code,
        resend: this.re_send
      }).then(res => {
        if (res.data.status) {
          this.$toasted.show(this.$t("confirmation code accepted"));
          this.nextStep();
          return;
        }
        this.$toasted.error(this.$t("confirmation code not accepted"));
      });
    },
    generateVerifyCode() {
      if (this.conditionAccepted) {
        let url = `signup/get-confirm-code`;
        console.log(this.config.baseUrl, this.config.apiVersion);
        this.$toasted.show(this.$t("wait") + "...");
        FhsAxios.get(url, {
          data: {}
        }).then(res => {
          this.$toasted.clear();
          if (res.data.status) {
            this.timer(120);
            this.codeVerification = true;
            this.$toasted.show(
              this.$t("confirmation code sent to number") +
                " " +
                `${this.oldPhoneValue}`
              //this.$t("confirmation code sent to number") + " " + ${this.oldPhoneValue}
            );
            return;
          }
          this.$toasted.error(this.$t("confirmation code not sent"));
        });
      } else {
        this.$toasted.show(this.$t("accept contract condition"));
      }
    },
    savePhone() {
      this.timer_seconds = 0;
      this.codeVerification = false;
      this.time = "0:00";
      let url = `user/update-phone`;
      FhsAxios.post(url, {
        phone: this.formatedPhoneValue
      }).then(res => {
        if (res.data.status) {
          // console.log(res.data.result);
          this.oldPhoneValue = this.formatedPhoneValue;
          this.$toasted.show(this.$t("number changed"));
          this.generateVerifyCode();
          return;
        }
        this.$toasted.error(this.$t("number not saved"));
      });
    }
  },
  beforeMount() {
    this.fetchData();
    // console.log(this.user_profile.user.phone);
    // this.formatedPhoneValue = this.user_profile.user.phone;
  }
};
</script>

<style scoped>
.form {
  color: #ffffff;
}

.form__red {
  color: red;
}

.form__row {
  display: flex;
}

.form__row_align-center {
  align-content: center;
}

.re_send_btn:disabled {
  opacity: 0.5;
}

.form__column {
  width: 50%;
}

.form__text_upper {
  text-transform: uppercase;
}

.form__paragraph {
  margin-top: 20px;
}

.form__input-container {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.form__checkbox-container {
  margin-top: 20px;
}

.form__input-container_margin-left {
  margin-left: 20px;
}

.form__label {
  margin-bottom: 10px;
  font-size: 15px;
}

.form__input {
  padding: 10px 15px;
  border-radius: 5px;
  outline: none;
  border: none;
}

.form__submit-button {
  width: 100%;
  margin-top: 20px;
  padding: 15px 0;
  font-size: 15px;
}
</style>
